// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1es9f","title":"styles_title__GtCRD"};